// import packages
import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import {Link, useLocation} from 'react-router-dom';

// Import assets
import '../assets/styles/components/footer.scss'
import {
    CallIcon, EmailFooterIcon,
    FacebookIcon, FooterArrIcon, FooterLogoIcon,
    InstagramIcon, LocationFooterIcon, PhoneDropDownIcon, TelegramIcon, ViberIcon, WhatsappIcon, WhatsUppIcon,
} from "../assets/images";

// Import utils
import {Dropdown} from "antd";

import {getPropsFromState} from "../redux/mapStateToProps";
import {AddSubscribers} from "../redux/actions";
import {getUrlWithLocal} from "../utils/getUrlWithLocal";
import {isEmail} from "validator";
import {InputGroup} from "./ui-elements/input-group/inputGroup";
import {Menu} from "antd";
import MapModal from "./modal/mapModal/MapModal";

function Footer(props) {

    const {requestLoading, contact, staticTexts} = props
    const [email, setEmail] = useState('')
    const [errorEmail, setErrorEmail] = useState(false)
    const [sliderShow, setSliderShow] = useState(false)
    const mainRef = useRef(null);
    const buttonRef = useRef(null)
    const [visible, setVisible] = useState(false)
    const location = useLocation();

    useEffect(() => {
        setErrorEmail(false)
        setEmail('')
    }, [location.pathname])

    const showTick = () => {
        setTimeout(
            () => {
                setEmail("")
                setErrorEmail(false)
            },
            2000,
        )

    }

    function closeModal() {
        setVisible(!visible)
    }

    function getInputValues(e) {
        setErrorEmail(false)
        const {value} = e.target;
        setEmail(value)
    }

    function addSubscribers() {
        if (email && isEmail(email)) {
            props.AddSubscribers({email: email}).then(() => {
                setEmail(email)
                showTick()
            }).catch((err) => {
                if (err.response?.data?.slug) {
                    setErrorEmail(true)
                }
            })
        } else {
            setErrorEmail(true)
        }
    }


    const phone = contact?.phoneNumber?.replace(/\D/g, '').substring(0, 12)
    const areaCode = phone?.substring(0, 3);
    const code = phone?.substring(3, 5);
    const content = phone?.substring(5, 7);
    const content1 = phone?.substring(7, 9);
    const content2 = phone?.substring(9, 12);

    const callMenu = (
        <Menu>
            <Menu.Item className={'callDropDown'}>
                <a href={`tel:+${phone}`} target={'_blank'}>
                    <PhoneDropDownIcon/>
                    <span>{`+${areaCode} (${code}) ${content} ${content1} ${content2}`}</span>
                </a>
                <a href={`viber://chat?number=%2B${phone}`} target={'_blank'}>
                    <ViberIcon/>
                    <span>{`+${areaCode} (${code}) ${content} ${content1} ${content2}`}</span>
                </a>
                <a href={`https://wa.me/+${phone}`} target={'_blank'}>
                    <WhatsUppIcon/>
                    <span>{`+${areaCode} (${code}) ${content} ${content1} ${content2}`}</span>
                </a>
            </Menu.Item>
        </Menu>
    );

    const handleClick = () => {
        window.scroll(0, 0)
    }

    function handleScroll() {
        //@ts-ignore
        setSliderShow(window?.scrollY > mainRef?.current?.clientHeight + 700)
    }

    useEffect(() => {
        window?.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [])


    const str = contact?.officeAddress;
    const parts = str?.split('%d');
    let part1 = ''
    let part2 = ''

    if (parts?.length === 2) {
        part1 = parts[0];
        part2 = parts[1];
    }

    return <footer className='footerWrapper'>
        <div className="top-side desktop" ref={mainRef}>
            {
                sliderShow && <div className={'scrollUp'} ref={buttonRef} onClick={handleClick}>
                    <FooterArrIcon/>
                </div>
            }
            <div className={'mobile-second-block'}>
                <Link to={getUrlWithLocal("/home")} className="logo-wrapper">
                    <img src={FooterLogoIcon} alt=""/>
                </Link>

                <div className="col">
                    <Link to={getUrlWithLocal(`/about`)}>
                        <p>{staticTexts?.footer_section_about}</p>
                    </Link>
                    <Link to={getUrlWithLocal(`/services`)}>
                        <p>{staticTexts?.header_item_services}</p>
                    </Link>
                    <Link to={getUrlWithLocal(`/works/all`)}>
                        <p>{staticTexts?.header_item_project}</p>
                    </Link>
                    <Link to={getUrlWithLocal(`/contact`)}>
                        <p>{staticTexts?.header_item_contact}</p>
                    </Link>
                </div>
            </div>
            <div className={'mobile-first-block'}>
                <div className="col">
                    <div className={'address-block'}>
                        <p onClick={() => setVisible(true)}><span><LocationFooterIcon/> {part1}</span> <span
                            className={'part2'}>{part2}</span></p>
                    </div>
                    <div className={'phoneNumber-block'}>
                        <a href={`tel:+${phone}`} target={'_blank'}>
                            <CallIcon/> <span>{`+${areaCode} (${code}) ${content} ${content1} ${content2}`}</span>
                        </a>
                    </div>
                    <div className={'email_block'}>
                        <EmailFooterIcon/> {contact?.email}
                    </div>
                </div>

                <div className={'social-block'}>
                    <div className="col">
                        <div>{staticTexts?.header_item_info}</div>
                        <div className="social-wrapper">
                            {
                                contact?.facebookUrl &&
                                <a href={contact?.facebookUrl} target={'_blank'} rel="noreferrer"><FacebookIcon/></a>
                            }
                            {
                                contact?.instagramUrl &&
                                <a href={contact?.instagramUrl} target={'_blank'} rel="noreferrer"><InstagramIcon/></a>
                            }
                            {
                                phone && <a href={`https://wa.me/+${phone}`} target={'_blank'}><WhatsappIcon/></a>
                            }
                            {
                                contact?.telegramUrl &&
                                <a href={contact?.telegramUrl} target={'_blank'} rel="noreferrer"><TelegramIcon/></a>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/*<div className='mobile-developed-by'>{staticTexts?.footer_section_developed_by_text}*/}
            {/*    <a href="https://solidy.am/" target="_blank" rel="noreferrer">Solidy</a>*/}
            {/*</div>*/}
        </div>
        <div className="bottom-side">
            <div className={'bottom-info'}>
                <div className={'privacy-block'}>
                    <div className={'privacy-policy'}>
                        {/*<Link to={getUrlWithLocal(`/privacy-policy`)}>*/}
                        {/*        <p>{staticTexts?.footer_section_privacy}</p>*/}
                        {/*    </Link>*/}
                        <Link to={getUrlWithLocal(`/privacy-policy`)}>
                            <p>{staticTexts?.footer_privacy_policy}</p>
                        </Link>
                    </div>
                    <div className={'footer_text'}>{staticTexts?.footer_section_copyright_text}</div>
                </div>
                <div className='developed-by'>{staticTexts?.footer_section_developed_by_text}
                    <a href="https://solidy.am/" target="_blank" rel="noreferrer">Solidy</a>
                </div>
            </div>
        </div>
        {
            visible && <MapModal closeModal={closeModal}
                                 visible={visible}/>
        }
    </footer>

}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'selectedLanguage',
        'staticTexts',
        'contact',
        'requestLoading',
    ])
};

const mapDispatchToProps = {
    AddSubscribers
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
